import api from "@/services/api/axios-client";
import { useQuery } from "@tanstack/react-query";
import { FOUR_HOURS } from "@/constants";
import { ProducedByDto } from "./types";

export const useMetadataQuery = () => {
  return useQuery({
    queryKey: ["metadata-properties"],
    queryFn: async () =>
      api
        .metadataControllerGetMetadata()
        .then(
          ({
            data: {
              bynder,
              producers,
              channels,
              producedBy,
              launch,
              documentContentTypes,
            },
          }) => {
            return {
              bynder,
              producers,
              channels,
              producedBy: producedBy as ProducedByDto,
              launch,
              documentContentTypes,
            };
          },
        ),
    staleTime: FOUR_HOURS,
  });
};

export const useMarketProducersQuery = () => {
  return useQuery({
    queryKey: ["market-producers"],
    queryFn: async () =>
      api.metadataControllerGetMarketProducers().then((response) => {
        return response.data;
      }),
    staleTime: FOUR_HOURS,
  });
};
